var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.3591 12.7301C19.9891 12.7301 19.6791 12.4501 19.6391 12.0801C19.3991 9.88007 18.2191 7.90007 16.3991 6.64007C16.0691 6.41007 15.9891 5.96007 16.2191 5.63007C16.4491 5.30007 16.8991 5.22007 17.2291 5.45007C19.3991 6.96007 20.7991 9.32007 21.0891 11.9301C21.1291 12.3301 20.8391 12.6901 20.4391 12.7301C20.4091 12.7301 20.3891 12.7301 20.3591 12.7301Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.73931 12.78C3.71931 12.78 3.68931 12.78 3.66931 12.78C3.26931 12.74 2.97931 12.38 3.01931 11.98C3.28931 9.36996 4.66931 7.00996 6.81931 5.48996C7.13931 5.25996 7.59931 5.33996 7.82931 5.65996C8.05931 5.98996 7.97931 6.43996 7.65931 6.66996C5.85931 7.94996 4.68931 9.92996 4.46931 12.12C4.42931 12.5 4.10931 12.78 3.73931 12.78Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9906 21.1001C14.7606 21.6901 13.4406 21.9901 12.0606 21.9901C10.6206 21.9901 9.25059 21.6701 7.97059 21.0201C7.61059 20.8501 7.47059 20.4101 7.65059 20.0501C7.82059 19.6901 8.26059 19.5501 8.62059 19.7201C9.25059 20.0401 9.92059 20.2601 10.6006 20.3901C11.5206 20.5701 12.4606 20.5801 13.3806 20.4201C14.0606 20.3001 14.7306 20.0901 15.3506 19.7901C15.7206 19.6201 16.1606 19.7601 16.3206 20.1301C16.5006 20.4901 16.3606 20.9301 15.9906 21.1001Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0505 2.01001C10.5005 2.01001 9.23047 3.27001 9.23047 4.83001C9.23047 6.39001 10.4905 7.65001 12.0505 7.65001C13.6105 7.65001 14.8705 6.39001 14.8705 4.83001C14.8705 3.27001 13.6105 2.01001 12.0505 2.01001Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05047 13.8701C3.50047 13.8701 2.23047 15.1301 2.23047 16.6901C2.23047 18.2501 3.49047 19.5101 5.05047 19.5101C6.61047 19.5101 7.87047 18.2501 7.87047 16.6901C7.87047 15.1301 6.60047 13.8701 5.05047 13.8701Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9509 13.8701C17.4009 13.8701 16.1309 15.1301 16.1309 16.6901C16.1309 18.2501 17.3909 19.5101 18.9509 19.5101C20.5109 19.5101 21.7709 18.2501 21.7709 16.6901C21.7709 15.1301 20.5109 13.8701 18.9509 13.8701Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3a09403ee5ff248d5e43b8962502498f.svg";
export { ForwardRef as ReactComponent };